import { render, staticRenderFns } from "./m_indonesian_native_teacher_classA.vue?vue&type=template&id=5d2fa5dc&scoped=true"
import script from "./m_indonesian_native_teacher_classA.vue?vue&type=script&lang=js"
export * from "./m_indonesian_native_teacher_classA.vue?vue&type=script&lang=js"
import style0 from "./m_indonesian_native_teacher_classA.vue?vue&type=style&index=0&id=5d2fa5dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2fa5dc",
  null
  
)

export default component.exports